import type { CreateProps } from "react-admin";
import { BooleanInput, Create, SimpleForm, TextInput } from "react-admin";
import GroupedPermissionsInput from "@/components/GroupedPermissionsInput";
import { MadrasaOfficePresetButton } from "@/components/madrasa-office-preset/MadrasaOfficePresetButton";

type AdminCreateFormValues = {
  email?: string;
  phoneNumber?: string;
};

const validateInviteChannel = (values: AdminCreateFormValues): Record<string, string> => {
  const email = values.email?.trim();
  const phoneNumber = values.phoneNumber?.trim();
  if (email || phoneNumber) {
    return {};
  }
  return {
    email: "Provide email or phone number",
    phoneNumber: "Provide phone number or email",
  };
};

const AdminCreate = (props: CreateProps) => (
  <Create {...props}>
    <SimpleForm validate={validateInviteChannel}>
      <TextInput source="name" />
      <TextInput source="email" helperText="Optional if phone invite is used." />
      <TextInput
        source="phoneNumber"
        helperText="Optional E.164 phone (e.g. +919876543210), required if no email."
      />
      <BooleanInput
        label="Receive Male sadarat allocation reminders via WhatsApp"
        source="receiveSadaratAllocationRemindersMale"
        helperText="Requires a phone number. Daily digest when events still need a Male sadarat."
        fullWidth
        defaultValue={false}
      />
      <BooleanInput
        label="Receive Female sadarat allocation reminders via WhatsApp"
        source="receiveSadaratAllocationRemindersFemale"
        helperText="Requires a phone number. Daily digest when events still need a Female sadarat."
        fullWidth
        defaultValue={false}
      />
      <BooleanInput
        label="Receive same-day raza event reminders via WhatsApp"
        source="receiveRazaEventDayOfReminders"
        helperText="Requires a phone number. Morning WhatsApp for today's events that need sadarat."
        fullWidth
        defaultValue={false}
      />
      <BooleanInput
        label="Staff leave WhatsApp approver"
        source="receiveStaffLeaveApproverNotifications"
        helperText="Requires a phone number. Enables leave-approver bot identity and pending-leave WhatsApp notifies. Also grant Employees view and edit so they can review leave in JMS."
        fullWidth
        defaultValue={false}
      />
      <TextInput
        source="password"
        type="password"
        helperText="Optional. Leave empty to send a Google sign-in invite."
      />
      <MadrasaOfficePresetButton />
      <GroupedPermissionsInput source="permissions" reference="admins/permissions/available" />
    </SimpleForm>
  </Create>
);

export default AdminCreate;
